module.exports = __webpack_public_path__ + "img/task_inactive.ce371403.svg";